import { isString, get, omitBy, isNil } from 'lodash-es';
import moment from 'moment';
import type { CoreTypes } from '../../core';
import type { Syllabus } from '../types/syllabus';
import { getDivisionId, hasDivisionId, type DivisionScope } from './common';

/**
 * @deprecated This is only used for SCS. can be removed when scs use v2
 */
export default (
  syllabuses: (Extract<CoreTypes.Mixed.Syllabus, { id: string }> | string)[],
  domain?: DivisionScope
): Syllabus[] => {
  if (!Array.isArray(syllabuses))
    throw new Error('(SS12000::To::Syllabus) Syllabus input is not of array type', { cause: 'invalid_input' });

  if (!syllabuses.every((location) => isString(location) || isString(get(location, 'id'))))
    throw new Error('(SS12000::To::Syllabus) Some syllabuses are missing "id" values', { cause: 'invalid_input' });

  if (!domain && !syllabuses.every((syllabus) => !isString(syllabus) && hasDivisionId(syllabus)))
    throw new Error('(SS12000::To::Syllabus) Some top layer syllabuses are missing division values', { cause: 'invalid_input' });

  return syllabuses.map((syllabus) => ({
    id: `${ getDivisionId(syllabus, domain) }.${ isString(syllabus) ? syllabus : syllabus.id }`,
    ...!isString(syllabus) && {
      meta: {
        created:  moment(syllabus.createdAt).toISOString(),
        modified: moment(syllabus.updatedAt).toISOString()
      },
      ...omitBy({
        foreignId:          syllabus.ids,
        schoolType:         syllabus.schoolType,
        subjectDesignation: syllabus.subjectDesignation,
        subjectCode:        syllabus.subjectCode,
        subjectName:        syllabus.subjectName,
        official:           syllabus.official,
      }, isNil),
    }
  }));
};